import { get } from '@classic/Foundation/Services/ApiService'
import { EntitlementsDataTransferObject } from '../DataTransferObjects/EntitlementsDataTransferObject'

export function isEntitled(serviceName: string): Promise<EntitlementsDataTransferObject> {
  switch (serviceName) {
    case 'giddyUp':
      return isGiddyUpEntitled()
    default:
      return Promise.resolve(new EntitlementsDataTransferObject())
  }
}

function isGiddyUpEntitled(): Promise<EntitlementsDataTransferObject> {
  const url = '/api/entitlements/GetGiddyUpEntitlements'
  const promise = get<EntitlementsDataTransferObject>({ url })
  return promise.then()
}
